
import { Component, Vue, Prop, Watch, Emit, Model } from 'vue-property-decorator'
import Agreement from '@xt/www/components/business/course/agreement.vue'

@Component({
  components: {
    Agreement
  }
})
export default class AgreementModal extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ required: true }) type: string
  @Prop({ required: true }) id: string

  innerVisible: boolean = false

  get agreementData() {
    return {
      original: {
        productInfo: {
          id: this.id
        }
      }
    }
  }

  onInnerVisibleChange(val: boolean) {
    if (val) return
    this.onClose()
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.innerVisible = val
  }

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
